import { buttonVariants } from "~/components/ui/button";
import { useTranslations } from "~/hooks/useTranslations";
import { cn } from "~/lib/utils";

type Props = {
  className?: string;
  backgroundColor?: string;
};

export function SaleEnded({ backgroundColor, className }: Props) {
  const t = useTranslations();

  return (
    <div
      className={cn(
        buttonVariants({ variant: "outline", className: "bg-white/50" }),
        "w-full cursor-default text-[#525252]",
        className,
      )}
      style={{ backgroundColor }}
    >
      {t.sections.saleEndedText}
    </div>
  );
}
